import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../base-component/base-component';
import { html, nothing } from 'lit';
import { WishList } from '../interfaces/wish-list-items.interface';
import { hasWishListProducts, wishListDropdownButtons } from '../utils/wish-list.util';
import './wish-list-dropdown-options';
import "./wish-list-add-all-to-cart";
import { PageTypes } from '../../../common/utils/page-util';

@customElement('mhecomm-wish-list-item-header')
export class WishListItemHeader extends BaseComponent {

  @property({ type: Object })
  wishList?: WishList;

  @property({ type: Array })
  allowedActions?: string[] = wishListDropdownButtons();

  renderComp() {
    return html`
      ${this.wishList
        ? html` <div class="item row">
            <div class="col-9 col-md-8 p-4">
              <h1 class="fw-medium">${this.wishList.name}</h1>
            </div>
            <div class="col-3 d-flex d-md-none d-sm-flex align-items-center justify-content-end">
              <mhecomm-wish-list-dropdown-options
                .wishList=${this.wishList}
                ?dropDownView=${true}
                .dropDownItems=${this.allowedActions}
              ></mhecomm-wish-list-dropdown-options>
            </div>
            <div class="col-3 col-md-4 d-md-flex d-none align-items-center justify-content-end px-0">
              <mhecomm-wish-list-dropdown-options
                .wishList=${this.wishList}
                .dropDownItems=${this.allowedActions}
                ?iconView=${true}
              ></mhecomm-wish-list-dropdown-options>
            </div>
          </div>
          ${hasWishListProducts(this.wishList!) ? 
            html`
              <div class="item row mt-5">
                <mhecomm-wish-list-add-all-to-cart-button
                  .wishList=${this.wishList}
                  pageType=${PageTypes.MyAccountMyListPage}
                ></mhecomm-wish-list-add-all-to-cart-button>
              </div>
            ` :
            nothing
          }`
        : nothing}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-item-header': WishListItemHeader;
  }
}